import React, { useState } from 'react';
import { ShieldIcon, ChevronDownIcon, ArrowRightIcon } from 'lucide-react';
export function EngagedRights() {
  const [expandedSection, setExpandedSection] = useState<string | null>('intro');
  const toggleSection = (section: string) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };
  const rights = [{
    id: 'intro',
    title: 'مقدمة عن حقوق الزوجين',
    content: <>
          <p className="mb-4" data-id="element-1987">
            الزواج في الإسلام ميثاق غليظ، وقد نظم الإسلام العلاقة بين الزوجين
            بشكل دقيق، وحدد حقوق وواجبات كل منهما. وقد قال الله تعالى:
            "وَلَهُنَّ مِثْلُ الَّذِي عَلَيْهِنَّ بِالْمَعْرُوفِ" [البقرة: 228].
          </p>
          <p className="mb-4" data-id="element-1988">
            من المهم للمقبلين على الزواج أن يتعرفوا على هذه الحقوق والواجبات قبل
            الزواج، ليكون كل منهما على بينة من أمره، وليستعد نفسياً وعملياً
            للقيام بمسؤولياته.
          </p>
          <div className="p-4 bg-purple-50 rounded-md border border-purple-100" data-id="element-1989">
            <p className="text-purple-800" data-id="element-1990">
              <span className="font-bold" data-id="element-1991">ملاحظة هامة: </span>
              الحقوق والواجبات الزوجية ليست مجرد قواعد قانونية، بل هي إطار
              أخلاقي وروحي للعلاقة بين الزوجين، والأصل فيها المودة والرحمة
              والتعاون، وليس التنازع والمطالبة.
            </p>
          </div>
        </>,
    color: 'purple'
  }, {
    id: 'wife-rights',
    title: 'حقوق الزوجة على زوجها',
    content: <>
          <div className="space-y-4" data-id="element-1992">
            <div className="bg-rose-50 p-4 rounded-lg border border-rose-100" data-id="element-1993">
              <h4 className="font-bold text-rose-800 mb-2" data-id="element-1994">
                1. الحقوق المالية:
              </h4>
              <ul className="space-y-2" data-id="element-1995">
                <li className="flex items-start" data-id="element-1996">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-1997"></span>
                  <div data-id="element-1998">
                    <span className="font-medium" data-id="element-1999">المهر: </span>
                    <span className="text-slate-700" data-id="element-2000">
                      هو حق خالص للزوجة، يجب على الزوج دفعه كاملاً، ولا يحل له
                      أخذ شيء منه إلا برضاها.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2001">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2002"></span>
                  <div data-id="element-2003">
                    <span className="font-medium" data-id="element-2004">النفقة: </span>
                    <span className="text-slate-700" data-id="element-2005">
                      تشمل الطعام والكسوة والسكن وكل ما تحتاجه الزوجة بالمعروف
                      حسب قدرة الزوج.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2006">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2007"></span>
                  <div data-id="element-2008">
                    <span className="font-medium" data-id="element-2009">السكن المستقل: </span>
                    <span className="text-slate-700" data-id="element-2010">
                      من حقها أن يوفر لها سكناً مستقلاً مناسباً لها ولأولادها.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-sky-50 p-4 rounded-lg border border-sky-100" data-id="element-2011">
              <h4 className="font-bold text-sky-800 mb-2" data-id="element-2012">
                2. الحقوق المعنوية:
              </h4>
              <ul className="space-y-2" data-id="element-2013">
                <li className="flex items-start" data-id="element-2014">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2015"></span>
                  <div data-id="element-2016">
                    <span className="font-medium" data-id="element-2017">حسن المعاشرة: </span>
                    <span className="text-slate-700" data-id="element-2018">
                      قال تعالى: "وَعَاشِرُوهُنَّ بِالْمَعْرُوفِ" [النساء: 19]،
                      ويشمل ذلك الكلام الطيب والمعاملة اللطيفة.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2019">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2020"></span>
                  <div data-id="element-2021">
                    <span className="font-medium" data-id="element-2022">العدل: </span>
                    <span className="text-slate-700" data-id="element-2023">
                      إذا كان متزوجاً بأكثر من واحدة، فيجب عليه العدل بينهن في
                      المبيت والنفقة والمعاملة.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2024">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2025"></span>
                  <div data-id="element-2026">
                    <span className="font-medium" data-id="element-2027">
                      الستر وعدم إفشاء الأسرار:{' '}
                    </span>
                    <span className="text-slate-700" data-id="element-2028">
                      من حقها أن يستر عيوبها ولا يفشي أسرارها.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100" data-id="element-2029">
              <h4 className="font-bold text-amber-800 mb-2" data-id="element-2030">
                3. الحقوق الاجتماعية:
              </h4>
              <ul className="space-y-2" data-id="element-2031">
                <li className="flex items-start" data-id="element-2032">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2033"></span>
                  <div data-id="element-2034">
                    <span className="font-medium" data-id="element-2035">
                      زيارة الأهل وصلة الرحم:{' '}
                    </span>
                    <span className="text-slate-700" data-id="element-2036">
                      من حقها زيارة والديها وأقاربها بالمعروف.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2037">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2038"></span>
                  <div data-id="element-2039">
                    <span className="font-medium" data-id="element-2040">التعليم: </span>
                    <span className="text-slate-700" data-id="element-2041">
                      من حقها التعلم وتثقيف نفسها بما ينفعها في دينها ودنياها.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2042">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2043"></span>
                  <div data-id="element-2044">
                    <span className="font-medium" data-id="element-2045">العمل: </span>
                    <span className="text-slate-700" data-id="element-2046">
                      يمكن للزوجة العمل بشرط موافقة الزوج وأن يكون العمل مناسباً
                      ولا يتعارض مع واجباتها الأساسية.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </>,
    color: 'rose'
  }, {
    id: 'husband-rights',
    title: 'حقوق الزوج على زوجته',
    content: <>
          <div className="space-y-4" data-id="element-2047">
            <div className="bg-sky-50 p-4 rounded-lg border border-sky-100" data-id="element-2048">
              <h4 className="font-bold text-sky-800 mb-2" data-id="element-2049">
                1. الطاعة في المعروف:
              </h4>
              <ul className="space-y-2" data-id="element-2050">
                <li className="flex items-start" data-id="element-2051">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2052"></span>
                  <div data-id="element-2053">
                    <span className="font-medium" data-id="element-2054">طاعة الزوج: </span>
                    <span className="text-slate-700" data-id="element-2055">
                      يجب على الزوجة طاعة زوجها في غير معصية الله، لقول النبي ﷺ:
                      "لا طاعة لمخلوق في معصية الخالق".
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2056">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2057"></span>
                  <div data-id="element-2058">
                    <span className="font-medium" data-id="element-2059">الاستئذان عند الخروج: </span>
                    <span className="text-slate-700" data-id="element-2060">
                      من حق الزوج أن تستأذنه زوجته عند الخروج من البيت.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2061">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2062"></span>
                  <div data-id="element-2063">
                    <span className="font-medium" data-id="element-2064">القوامة: </span>
                    <span className="text-slate-700" data-id="element-2065">
                      الزوج هو القوّام على أسرته، وله حق الرعاية والإشراف، قال
                      تعالى: "الرِّجَالُ قَوَّامُونَ عَلَى النِّسَاءِ" [النساء:
                      34].
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100" data-id="element-2066">
              <h4 className="font-bold text-emerald-800 mb-2" data-id="element-2067">
                2. رعاية البيت والأولاد:
              </h4>
              <ul className="space-y-2" data-id="element-2068">
                <li className="flex items-start" data-id="element-2069">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-emerald-500 mt-2" data-id="element-2070"></span>
                  <div data-id="element-2071">
                    <span className="font-medium" data-id="element-2072">رعاية شؤون البيت: </span>
                    <span className="text-slate-700" data-id="element-2073">
                      من واجبات الزوجة الاهتمام بشؤون البيت وتنظيمه، وإن كان هذا
                      من باب التعاون وليس الإلزام الفقهي.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2074">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-emerald-500 mt-2" data-id="element-2075"></span>
                  <div data-id="element-2076">
                    <span className="font-medium" data-id="element-2077">حفظ مال الزوج: </span>
                    <span className="text-slate-700" data-id="element-2078">
                      من حق الزوج على زوجته أن تحفظ ماله ولا تتصرف فيه إلا
                      بإذنه.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2079">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-emerald-500 mt-2" data-id="element-2080"></span>
                  <div data-id="element-2081">
                    <span className="font-medium" data-id="element-2082">رعاية الأولاد: </span>
                    <span className="text-slate-700" data-id="element-2083">
                      من واجبات الزوجة تربية الأولاد ورعايتهم، بالتعاون مع
                      الزوج.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100" data-id="element-2084">
              <h4 className="font-bold text-amber-800 mb-2" data-id="element-2085">
                3. المعاشرة بالمعروف:
              </h4>
              <ul className="space-y-2" data-id="element-2086">
                <li className="flex items-start" data-id="element-2087">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2088"></span>
                  <div data-id="element-2089">
                    <span className="font-medium" data-id="element-2090">حسن المعاملة: </span>
                    <span className="text-slate-700" data-id="element-2091">
                      من حق الزوج على زوجته أن تعامله معاملة حسنة، وتحترمه
                      وتقدره.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2092">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2093"></span>
                  <div data-id="element-2094">
                    <span className="font-medium" data-id="element-2095">عدم إفشاء الأسرار: </span>
                    <span className="text-slate-700" data-id="element-2096">
                      من حقه أن تحفظ أسراره ولا تفشيها لأحد.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2097">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-2098"></span>
                  <div data-id="element-2099">
                    <span className="font-medium" data-id="element-2100">الاهتمام بمظهرها: </span>
                    <span className="text-slate-700" data-id="element-2101">
                      من حقه أن تهتم الزوجة بمظهرها ونظافتها، وأن تتزين له في
                      البيت.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </>,
    color: 'sky'
  }, {
    id: 'mutual-rights',
    title: 'الحقوق المشتركة بين الزوجين',
    content: <>
          <div className="space-y-4" data-id="element-2102">
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100" data-id="element-2103">
              <h4 className="font-bold text-amber-800 mb-2" data-id="element-2104">1. حسن العشرة:</h4>
              <p className="mb-3 text-slate-700" data-id="element-2105">
                قال تعالى: "وَعَاشِرُوهُنَّ بِالْمَعْرُوفِ" [النساء: 19]، وقال
                أيضاً: "وَلَهُنَّ مِثْلُ الَّذِي عَلَيْهِنَّ بِالْمَعْرُوفِ"
                [البقرة: 228].
              </p>
              <p className="text-slate-700" data-id="element-2106">
                من حق كل من الزوجين على الآخر المعاملة الحسنة، والكلام الطيب،
                والبشاشة، والتغافل عن الهفوات، والصبر على الأخطاء.
              </p>
            </div>
            <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100" data-id="element-2107">
              <h4 className="font-bold text-emerald-800 mb-2" data-id="element-2108">
                2. حفظ الأسرار:
              </h4>
              <p className="text-slate-700" data-id="element-2109">
                من حق كل من الزوجين على الآخر أن يحفظ أسراره، وألا يفشي ما يكون
                بينهما من أمور خاصة، لقول النبي ﷺ: "إن من أشر الناس عند الله
                منزلة يوم القيامة الرجل يفضي إلى امرأته وتفضي إليه ثم ينشر سرها"
                [رواه مسلم].
              </p>
            </div>
            <div className="bg-sky-50 p-4 rounded-lg border border-sky-100" data-id="element-2110">
              <h4 className="font-bold text-sky-800 mb-2" data-id="element-2111">
                3. التعاون على طاعة الله:
              </h4>
              <p className="text-slate-700" data-id="element-2112">
                من حق كل من الزوجين على الآخر أن يعينه على طاعة الله، ويذكره
                بها، ويشجعه عليها، قال تعالى: "وَتَعَاوَنُوا عَلَى الْبِرِّ
                وَالتَّقْوَى" [المائدة: 2].
              </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg border border-purple-100" data-id="element-2113">
              <h4 className="font-bold text-purple-800 mb-2" data-id="element-2114">
                4. التشاور في أمور الأسرة:
              </h4>
              <p className="text-slate-700" data-id="element-2115">
                من الحقوق المشتركة التشاور في أمور الأسرة، وخاصة ما يتعلق
                بالأولاد وتربيتهم، قال تعالى: "وَأْتَمِرُوا بَيْنَكُم
                بِمَعْرُوفٍ" [الطلاق: 6].
              </p>
            </div>
            <div className="bg-rose-50 p-4 rounded-lg border border-rose-100" data-id="element-2116">
              <h4 className="font-bold text-rose-800 mb-2" data-id="element-2117">5. الاستمتاع:</h4>
              <p className="text-slate-700" data-id="element-2118">
                من حق كل من الزوجين على الآخر الاستمتاع به، وهو حق متبادل
                بينهما، قال تعالى: "هُنَّ لِبَاسٌ لَّكُمْ وَأَنتُمْ لِبَاسٌ
                لَّهُنَّ" [البقرة: 187].
              </p>
            </div>
          </div>
        </>,
    color: 'amber'
  }, {
    id: 'conditions',
    title: 'الشروط في عقد الزواج',
    content: <>
          <p className="mb-4" data-id="element-2119">
            يمكن لكل من الزوجين أن يشترط في عقد الزواج شروطاً لا تخالف مقتضى
            العقد ولا تحل حراماً أو تحرم حلالاً. وهذه الشروط ملزمة إذا وافق
            عليها الطرفان.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-2120">
            <div className="bg-rose-50 p-4 rounded-lg border border-rose-100" data-id="element-2121">
              <h4 className="font-bold text-rose-800 mb-2" data-id="element-2122">
                شروط يمكن للزوجة اشتراطها:
              </h4>
              <ul className="space-y-2" data-id="element-2123">
                <li className="flex items-start" data-id="element-2124">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2125"></span>
                  <span className="text-slate-700" data-id="element-2126">
                    ألا يمنعها من إكمال دراستها
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2127">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2128"></span>
                  <span className="text-slate-700" data-id="element-2129">
                    ألا يمنعها من العمل في مجال تخصصها
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2130">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2131"></span>
                  <span className="text-slate-700" data-id="element-2132">
                    أن يكون لها سكن مستقل عن أهل الزوج
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2133">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-2134"></span>
                  <span className="text-slate-700" data-id="element-2135">ألا يتزوج عليها</span>
                </li>
              </ul>
            </div>
            <div className="bg-sky-50 p-4 rounded-lg border border-sky-100" data-id="element-2136">
              <h4 className="font-bold text-sky-800 mb-2" data-id="element-2137">
                شروط يمكن للزوج اشتراطها:
              </h4>
              <ul className="space-y-2" data-id="element-2138">
                <li className="flex items-start" data-id="element-2139">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2140"></span>
                  <span className="text-slate-700" data-id="element-2141">
                    أن تساهم في نفقات البيت إذا كانت تعمل
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2142">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2143"></span>
                  <span className="text-slate-700" data-id="element-2144">
                    أن تعيش معه في بلد معين
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2145">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2146"></span>
                  <span className="text-slate-700" data-id="element-2147">
                    تحديد عدد مرات زيارة أهلها
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2148">
                  <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-2149"></span>
                  <span className="text-slate-700" data-id="element-2150">
                    ألا تعمل في مكان معين أو وظيفة معينة
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="p-4 bg-amber-50 rounded-lg border border-amber-100" data-id="element-2151">
            <p className="text-amber-800" data-id="element-2152">
              <span className="font-bold" data-id="element-2153">ملاحظة هامة: </span>
              يجب مناقشة الشروط بوضوح وصراحة قبل العقد، وتوثيقها في العقد لتجنب
              الخلافات المستقبلية. والأفضل استشارة عالم شرعي لمعرفة الشروط
              المقبولة شرعاً.
            </p>
          </div>
        </>,
    color: 'green'
  }, {
    id: 'advice',
    title: 'نصائح للمقبلين على الزواج',
    content: <>
          <div className="space-y-4" data-id="element-2154">
            <div className="bg-purple-50 p-4 rounded-lg border border-purple-100" data-id="element-2155">
              <p className="text-purple-800 mb-3 font-bold" data-id="element-2156">
                1. تعلموا حقوق وواجبات الزوجين قبل الزواج:
              </p>
              <p className="text-slate-700" data-id="element-2157">
                المعرفة المسبقة بالحقوق والواجبات تساعد في تجنب الكثير من
                المشاكل والخلافات. اقرؤوا كتباً موثوقة عن الزواج في الإسلام،
                واحضروا دورات تأهيلية للزواج.
              </p>
            </div>
            <div className="bg-sky-50 p-4 rounded-lg border border-sky-100" data-id="element-2158">
              <p className="text-sky-800 mb-3 font-bold" data-id="element-2159">
                2. ناقشوا توقعاتكما من الحياة الزوجية:
              </p>
              <p className="text-slate-700" data-id="element-2160">
                تحدثوا بصراحة عن توقعاتكما من الحياة الزوجية، وعن أدوار كل منكما
                في البيت، وعن الأمور المالية، وتربية الأطفال، وغيرها من القضايا
                المهمة.
              </p>
            </div>
            <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100" data-id="element-2161">
              <p className="text-emerald-800 mb-3 font-bold" data-id="element-2162">
                3. استشيروا من تثقون بعلمهم وخبرتهم:
              </p>
              <p className="text-slate-700" data-id="element-2163">
                استشيروا العلماء والمختصين في قضايا الزواج، واستفيدوا من خبرات
                من سبقوكم في الزواج، خاصة الوالدين والأقارب الناجحين في حياتهم
                الزوجية.
              </p>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100" data-id="element-2164">
              <p className="text-amber-800 mb-3 font-bold" data-id="element-2165">
                4. ضعوا الله نصب أعينكم:
              </p>
              <p className="text-slate-700" data-id="element-2166">
                تذكروا دائماً أن الزواج عبادة وطاعة لله، وأن الهدف منه هو السكن
                والمودة والرحمة. فاحرصوا على تقوى الله في معاملة بعضكم البعض.
              </p>
            </div>
            <div className="bg-rose-50 p-4 rounded-lg border border-rose-100" data-id="element-2167">
              <p className="text-rose-800 mb-3 font-bold" data-id="element-2168">
                5. تعلموا فن التنازل والتسامح:
              </p>
              <p className="text-slate-700" data-id="element-2169">
                الحياة الزوجية قائمة على التنازلات المتبادلة والتسامح. فتعلموا
                متى تتنازلون ومتى تتمسكون برأيكم، وكيف تتسامحون مع أخطاء بعضكم
                البعض.
              </p>
            </div>
          </div>
          <div className="mt-6 flex justify-center" data-id="element-2170">
            <a href="#" className="inline-flex items-center px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors duration-200 shadow-md hover:shadow-lg" data-id="element-2171">
              <span data-id="element-2172">احجز استشارة مع مختص</span>
              <ArrowRightIcon className="h-4 w-4 mr-2" data-id="element-2173" />
            </a>
          </div>
        </>,
    color: 'purple'
  }];
  return <div className="max-w-4xl mx-auto" data-id="element-2174">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-purple-900" data-id="element-2175">
        حقوق الزوجين للمقبلين على الزواج
      </h2>
      <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-2176">
        <div className="flex items-center mb-6" data-id="element-2177">
          <ShieldIcon className="h-8 w-8 text-purple-600 ml-4" data-id="element-2178" />
          <h3 className="text-xl font-bold text-purple-800" data-id="element-2179">
            تعرف على حقوقك وواجباتك قبل الزواج
          </h3>
        </div>
        <p className="text-slate-700 leading-relaxed mb-6" data-id="element-2180">
          المعرفة بحقوق وواجبات الزوجين في الإسلام من أهم خطوات الاستعداد
          للزواج. تساعدك هذه المعرفة على بناء توقعات واقعية، وتجنب الخلافات
          المستقبلية، وبناء أسرة مستقرة وسعيدة.
        </p>
        <div className="space-y-4" data-id="element-2181">
          {rights.map(section => <div key={section.id} className={`bg-white rounded-lg border transition-all duration-300 ${expandedSection === section.id ? `border-${section.color}-300 shadow-md` : 'border-slate-200'}`} data-id="element-2182">
              <button onClick={() => toggleSection(section.id)} className="w-full p-4 flex justify-between items-center focus:outline-none" data-id="element-2183">
                <div className="flex items-center" data-id="element-2184">
                  <div className={`w-3 h-3 rounded-full mr-3 bg-${section.color}-500`} data-id="element-2185"></div>
                  <h3 className="font-bold text-lg" data-id="element-2186">{section.title}</h3>
                </div>
                <ChevronDownIcon className={`h-5 w-5 transition-transform duration-200 ${expandedSection === section.id ? 'transform rotate-180' : ''}`} data-id="element-2187" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${expandedSection === section.id ? 'max-h-[2000px]' : 'max-h-0'}`} data-id="element-2188">
                <div className="p-4 border-t border-gray-100" data-id="element-2189">
                  {section.content}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}